export default __webpack_public_path__ + "static/media/facts_300.d4130618.webp";